import {BootstrapTableProps} from 'react-bootstrap-table-next'

export const ProductStockstatusCssClasses = ['danger', 'success', '', '']
export const ProductStockstatusTitles = ['Inactivo', 'Activo', '', '']
export const ProductStockTypeCssClasses = ['success', 'primary', '']
export const ProductStockTypeTitles = ['Business', 'Individual', '']
export const defaultSorted: BootstrapTableProps['defaultSorted'] = [{dataField: 'quantity', order: 'desc'}]

export const sizePerPageList = [
  {text: '10', value: 10},
  {text: '100', value: 100},
  {text: '250', value: 250},
  {text: '500', value: 500},
  {text: '1000', value: 1000},
]

export const initialFilter = {
  filter: {
    nom_area: '',
    tel_area: '',
  },
  sortProductStock: 'asc', // asc||desc
  sortField: 'id',
  pageNumber: 1,
  pageSize: 100,
}

export const initialValues = {
  data: {
    entities: [],
    totalCount: 0,
    errorMessage: '',
  },
  totalCount: 0,
}

// export const initialFilter = {
//   filter: {
//     lastName: "",
//     firstName: "",
//     email: "",
//     ipAddress: ""
//   },
//   sortProductStock: "asc", // asc||desc
//   sortField: "id",
//   pageNumber: 1,
//   pageSize: 10
// };
